import { render, staticRenderFns } from "./Vframe.vue?vue&type=template&id=5ddd0ce9&lang=pug"
import script from "./Vframe.vue?vue&type=script&lang=js"
export * from "./Vframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports